import { defineMessages } from 'react-intl';

export const messages: {
	addTranslation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	back: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	defaultLanguageDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	defaultLanguageIconLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	description: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateDescription: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	emptyStateHeader: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	languageFieldLabel: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	loadingLanguages: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	noFields: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	panelTitle: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	removeTranslation: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	selectLanguage: {
		defaultMessage: string;
		description: string;
		id: string;
	};
	title: {
		defaultMessage: string;
		description: string;
		id: string;
	};
} = defineMessages({
	addTranslation: {
		id: 'company-hub-common.config-panel.manage-translations.addTranslation',
		defaultMessage: 'Add translation',
		description: 'Button text for adding a new locale translation.',
	},
	back: {
		id: 'company-hub-common.config-panel.manage-translations.back',
		defaultMessage: 'Back',
		description: 'Accessible label for returning from the translations view.',
	},
	description: {
		id: 'company-hub-common.config-panel.manage-translations.description',
		defaultMessage: 'Manage and update your translations here.',
		description: 'Help text shown above the translations view.',
	},
	loadingLanguages: {
		id: 'company-hub-common.config-panel.manage-translations.loadingLanguages',
		defaultMessage: 'Loading available languages',
		description: 'Accessible label for the spinner shown while translation languages are loading.',
	},
	defaultLanguageDescription: {
		id: 'company-hub-common.config-panel.manage-translations.defaultLanguageDescription',
		defaultMessage: 'Your default language is {defaultLanguage}.',
		description: 'Descriptive text shown below the default locale row in the translations panel.',
	},
	defaultLanguageIconLabel: {
		id: 'company-hub-common.config-panel.manage-translations.defaultLanguageIconLabel',
		defaultMessage: 'Default language',
		description: 'Accessible label for the icon shown beside the default language.',
	},
	emptyStateHeader: {
		id: 'company-hub-common.config-panel.manage-translations.emptyStateHeader',
		defaultMessage: 'No translations yet',
		description: 'Header text for the empty state shown when no translations have been added.',
	},
	emptyStateDescription: {
		id: 'company-hub-common.config-panel.manage-translations.emptyStateDescription',
		defaultMessage: 'Convey your help center content in multiple languages',
		description: 'Description text for the empty state shown when no translations have been added.',
	},
	languageFieldLabel: {
		id: 'company-hub-common.config-panel.manage-translations.languageFieldLabel',
		defaultMessage: 'Language',
		description: 'Label for a translation language select field.',
	},
	noFields: {
		id: 'company-hub-common.config-panel.manage-translations.noFields',
		defaultMessage: 'This extension does not expose any translatable fields.',
		description: 'Text shown when the extension has no translatable fields.',
	},
	panelTitle: {
		id: 'company-hub-common.config-panel.manage-translations.panelTitle',
		defaultMessage: 'Translations',
		description: 'Panel title shown when the translations view is open.',
	},
	removeTranslation: {
		id: 'company-hub-common.config-panel.manage-translations.removeTranslation',
		defaultMessage: 'Remove translation',
		description: 'Button text for removing a locale translation.',
	},
	selectLanguage: {
		id: 'company-hub-common.config-panel.manage-translations.selectLanguage',
		defaultMessage: 'Select language',
		description: 'Section heading shown above the language picker.',
	},
	title: {
		id: 'company-hub-common.config-panel.manage-translations.title',
		defaultMessage: 'Manage translations',
		description: 'Legacy section title for the shared manage translations form.',
	},
});
